import { getReq, createUrl } from "@/infra/http";
import { BaseResponseModel } from "@/models/core.model";
import { AdminWaitingJob, GetUserRegisterSummaryRequest, GetUserRegisterSummaryResponse } from "@/models/dashboard.model";

export const getAdminWaitingJobs = async (): Promise<BaseResponseModel<AdminWaitingJob[]>> => {
  return await getReq(createUrl("a/Dashboard/GetAdminWaitingJobs")
  ).then((res: any) => res.data);
};

export const getTotalUsers = async (): Promise<BaseResponseModel<number>> => {
  return await getReq(createUrl("a/Dashboard/GetTotalUsers")
  ).then((res: any) => res.data);
};

export const getUserRegisterSummary = async (req: GetUserRegisterSummaryRequest): Promise<BaseResponseModel<GetUserRegisterSummaryResponse>> => {
  return await getReq(createUrl("a/Dashboard/GetUserRegisterSummary"), {params: req}
  ).then((res: any) => res.data);
};